// @ts-check

/** @type {import('tailwindcss').Config['theme']} */
const colors = require('./colors')
const colorVars = require('./theme-colors')

const theme = {
  // edit your tailwind theme here!
  // https://tailwindcss.com/docs/adding-custom-styles
  variables: {
    '--rem': 17,
    ...colorVars,
  },
  extend: {
    colors,
    spacing: {
      1: '4px',
      2: '8px',
      3: '16px',
      4: '24px',
      5: '32px',
      6: '40px',
      7: '48px',
      8: '56px',
      9: '64px',
      10: '72px',
      '4/2': '12px',
    },
    fontSize: {
      '5xl': '2.5rem',
    },
  },
}

module.exports = {
  theme,
}
